export const enum AxDurum {
    Calculating = 0,
    CalculationCompleted = 1,
    SentToAxapta = 2,
}
